import { $t } from '@/i18n'
import { CREATE, EDIT } from '@/helpers/constantes/promptConstants'

export const modalAddPromptMixin = {
  methods: {
    promptActions () {
      let info = ''
      let title = ''
      const currentUrl = new URL(window.location)
      const paramValue = currentUrl.searchParams.get('action')
      const action = (paramValue) || this.$route.query.action
      switch (action) {
        case 'create':
          info = (this.$route.name === 'manage-posts') ? $t('prompt.infoRecordingPrompt', { titre: this.localPromptData.titre }) + $t('prompt.infoRecordingPostPrompt') : $t('prompt.infoRecordingPrompt', { titre: this.localPromptData.titre })
          title = $t('prompt.creationPrompt')
          break
        case 'edit':
          info = $t('prompt.infoUpdatingPrompt', { titre: this.localPromptData.titre })
          title = $t('prompt.editPrompt')
          break
      }
      if (
        !this.isNotValidateTitre &&
          !this.isNotValidateTon
      ) {
        this.$confirm(info, title, {
          confirmButtonText: $t('prompt.validate'),
          cancelButtonText: $t('prompt.cancel'),
          type: 'info'
        }).then((response) => {
          if (response === 'confirm') {
            // Préserver l'objet datum existant et modifier seulement les champs
            const selectedDonnees = this.getListDataInitialByJob.filter((donnee) => this.checkedData.includes(donnee.libelle))
            
            // Si datum n'existe pas, le créer
            if (!this.localPromptData.datum) {
              this.localPromptData.datum = { id: null, champs: [] }
            }
            
            // Modifier seulement le tableau champs
            this.localPromptData.datum.champs = selectedDonnees
            this.localPromptData.annonceurId = this.getSitimmoUser.id
            switch (action) {
              case CREATE:
                this.addPrompt()
                break
              case EDIT:
                this.editPrompt()
                break
            }
          }
        })
      }
    },
    editPrompt () {
      try {
        this.$store.dispatch('promptLibraries/addOrUpdatePrompt', this.localPromptData)
        this.$message({
          type: 'success',
          message: $t('prompt.updatedSuccess')
        })
        this.formSubmitted = false
        this.$store.commit('promptLibraries/resetPrompt')
        this.$router.push({ path: this.$route.path, query: { action: CREATE } })
      } catch (e) {
        this.$message({
          type: 'error',
          message: $t('prompt.updatedFailed')
        })
      }
    },
    addPrompt () {
      try {
        this.$store.dispatch('promptLibraries/addOrUpdatePrompt', this.localPromptData)
        this.$message({
          type: 'success',
          message: $t('prompt.recordSuccess')
        })
        this.formSubmitted = false
        this.$store.commit('promptLibraries/resetPrompt')
      } catch (e) {
        this.$message({
          type: 'error',
          message: $t('prompt.recordFailed')
        })
      }
    }
  }
}
